import { ChatBotApi } from "@/chatBot/api/requests";
import { URLS } from "../define";
import { IUnifiedPortalAPI, UnifiedPortalAPI } from "./api/unifiedPortal";
import { useConfigStore } from "@/stores/config";

export const unifiedApi: IUnifiedPortalAPI = new UnifiedPortalAPI(URLS.UP_ENDPOINT);

//Export a singleton instance of the ChatBotApi
export const chatBotApi: ChatBotApi = new ChatBotApi("http://localhost:3000");
// export const unifiedApi: IUnifiedPortalAPI = FLAGS.IS_DEBUG
//   ? new UnifiedPortalAPIMock(URLS.UP_ENDPOINT)
//   : new UnifiedPortalAPI(URLS.UP_ENDPOINT);

export const initialize = async () => {
  const store = useConfigStore();
  await store.getConfig();
};
